<h2 mat-dialog-title>{{ data.title | translate }}

 <div class="add-button-container">
  <button matTooltip="Rolle Hinzufügen" (click)="addRolle()" mat-mini-fab color="warn" aria-label="Add a address" class="pluscolor">
    <mat-icon>add</mat-icon>
  </button>
  </div>
</h2>
<div *ngIf="$error | async as error">
  {{ error }}
</div>
<mat-dialog-content class="mat-typography">
<app-rollenverwaltung-table
  [rollen]="$rollen | async"
></app-rollenverwaltung-table>

</mat-dialog-content>
<mat-dialog-actions align="end">

  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
